/**
 * teamColorStore — backend-backed shim preserving the legacy function names.
 *
 * Reads pull from Redux (the `teams` slice), writes dispatch
 * `updateTeam(id, { color })`, which calls `PUT /team/:id`. The curated
 * `TEAM_COLOR_PALETTE` constant is still exported so the color-picker UI
 * stays unchanged.
 *
 * `onTeamColorsChange` is a no-op — Redux state changes already drive
 * re-renders via `useSelector`.
 */

import store from "../../store";
import { updateTeam } from "../../redux/teams/actions";

export const TEAM_COLOR_PALETTE = [
  "#3B7CCB", // blue
  "#E16C8B", // rose
  "#16A34A", // green
  "#F59E0B", // amber
  "#A855F7", // purple
  "#0EA5E9", // sky
  "#EC4899", // pink
  "#EF4444", // red
  "#14B8A6", // teal
  "#F97316", // orange
];

const findTeamByName = (name) => {
  if (!name) return undefined;
  const list = store.getState()?.teamsReducer?.list;
  return Array.isArray(list) ? list.find((t) => t.name === name) : undefined;
};

export function getTeamColor(name, fallback = "") {
  if (!name) return fallback;
  return findTeamByName(name)?.color || fallback;
}

/**
 * Set the brand color for a team. No-ops if the team is unknown (the
 * Manage Teams panel always sets a color for an existing team, so this is
 * defensive rather than load-bearing).
 */
export function setTeamColor(name, hex) {
  const team = findTeamByName(name);
  if (!team) return;
  store.dispatch(updateTeam(team._id, { color: hex || "" }));
}

export function getAllTeamColors() {
  const list = store.getState()?.teamsReducer?.list || [];
  const out = {};
  list.forEach((t) => {
    if (t?.name && t?.color) out[t.name] = t.color;
  });
  return out;
}

export function onTeamColorsChange(_handler) {
  return () => {};
}
